<template>
    <div class = "login-main" v-show="showLabel==2">
        <div class = "back" style="display:flex;" @click="$emit('change',1)">
            <span class="el-icon-back" >{{$t('login.back')}}</span>
        </div>
        <div style="margin-bottom: 30px;">
            <span class = "title" style="font-size:25px;">{{$t('login.Please_enter_your_email')}}</span>
        </div>
            <div style="display:flex;width:320px">
                <span class="email-text">{{$t('login.email')}}</span>
                <span class="star">*</span>
                <el-input class="email-input" v-model="username" placeholder=""></el-input>
            </div>
        <el-button class="next-button">{{$t('login.next')}}</el-button>
    </div>
</template>

<script>
import {load} from '@/api/api'
export default{
    name:'ForgetView',
    data(){
        return{
            username:'',
            password:'',
            isAgree:false
        }
    },
    props:{
        showLabel:{
            type:Number,
            required:true,
            default(){
                return 1
            }
        }
    },
    methods:{
        handleSubmit() {
      if(this.username==''||this.password==''){
        this.$message.error('账号密码不能为空');
        return;
      }
      if(!this.isAgree){
        this.$message.error('请阅读用户协议和隐私政策并同意');
        return;
      }
            load({
                UserName: this.username,
                PassWord: this.password
            }).then(
              this.$router.push({
                    path: 'home'
                })
            )
        },
    }
}
</script>

<style>
.el-icon-back{
    margin-left:0px;margin-right: auto;margin-bottom: 20px;color:#ccc
}
.el-icon-back:hover{
    color:black
}
.login-main{
    border-radius:12px;
    margin-top:150px;
    margin-right:30px;
    padding:30px;
    padding-top: 80px;
    background-color:#ffffff;
    /* border:1px solid #ccc; */
    width:20%;
    display:inline block;
    height:100%;
}
.title{
    padding: 100px 0 0;
    color: #141414;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
}
.email-text{
    margin-left:30px;
    margin-right: 0;
    font-size:18px;
    height:40px;
    margin-top:20px;
}
.star{
    margin-left:10px;
    margin-right: auto;
    font-size:18px;
    height:40px;
    margin-top:20px;
    color:red;
}
.email-input{
    margin-left:auto;
    margin-right:0;
    font-size:18px;
    height:40px;
    margin-top:20px;
    width:200px;
}
.next-button{
    margin-top:30px;
    background:#0049c8;
    color:#ffffff;
    width:80%;
}
</style>